import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["input", "label"];

  connect() {
    this.update();
  }

  update() {
    if (!this.hasInputTarget || !this.hasLabelTarget) return;
    const files = this.inputTarget.files;
    if (!files || files.length === 0) {
      this.labelTarget.textContent = this.element.dataset.defaultLabel || 'Anexar';
    } else if (files.length === 1) {
      this.labelTarget.textContent = files[0].name;
    } else {
      this.labelTarget.textContent = `${files.length} arquivos`;
    }
  }
}
